<template>
  <CModal :show.sync="show">
    <template #header>
      <h6 class="modal-title">Add Sector</h6>
    </template>
    <CInput
        :horizontal="true"
        v-model="sectorName"
        placeholder="Enter Name"
        label="Name"
        name="name"
    ></CInput>
    
    <template #footer>
      <CButton @click="closeModal" color="primary">Cancel</CButton>
      <CButton @click="emitSector" color="success">OK</CButton>
    </template>
  </CModal>
</template>

<script>
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  name: 'SectorAddModal',
  components: {
    
  },
  data() {
    return {
      sectorName: '',
    };
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    
    emitSector() {
      this.$emit('newSector', this.sectorName);
      this.closeModal(); // If you have a method to close the modal
    },
    closeModal() {
      this.$emit('update:show', false);
    }
  }
};
</script>
